import { useCallback } from "react";
import { createViewEmailCommunications } from "@/ui/views";
import type { TApiEmailLogStatus } from "@/apis/proda_finance/types";
import type { TCompositionDeps } from "@/ui/compositionRoot/types";

export function wireEmailCommunications({ useAppStore, api }: TCompositionDeps) {
    const ViewEmailCommunications = createViewEmailCommunications({
        useCases: () => {
            const effectiveCompanyId = useAppStore(
                (state) => state.effectiveCompanyId ?? state.user?.companyId,
            );
            const loadEmailLogs = useCallback(
                async (params: { page: number; pageSize: number; status?: TApiEmailLogStatus }) => {
                    const result = await api.emailLogs.list({
                        page: params.page,
                        page_size: params.pageSize,
                        status: params.status,
                    });
                    return { items: result.items, total: result.total };
                },
                // eslint-disable-next-line react-hooks/exhaustive-deps
                [effectiveCompanyId],
            );
            return { loadEmailLogs };
        },
    });

    return { ViewEmailCommunications };
}
